/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import { Layout } from '../types/Layout'

interface LayoutContextType {
  layout: Layout
  setLayout: (layout: Layout) => any
}
const initialState: LayoutContextType = {
  layout: {
    isMenuOpen: false,
    isFilterOpen: true
  },
  setLayout: () => {}
}

const storageItem = 'layout-main-portal-analytics'
const localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, ...newState }
}

export const LayoutContext = createContext(initialState)

const LayoutContextProvider: React.FC = (props: any) => {
  const [layout, setLayout] = useReducer(reducer, localState || initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(layout))
  }, [layout])

  return (
    <LayoutContext.Provider value={{ layout, setLayout }}>
      {props.children}
    </LayoutContext.Provider>)
}

export default LayoutContextProvider
